/**
 * Frame and mat pricing data
 * Prices are per linear meter of material (EUR).
 * Total cost = perimeter × price_per_meter + labour + extras.
 */

/** Pricing per material type (EUR per linear meter of frame) */
export const FRAME_MATERIAL_PRICES: Record<string, number> = {
  wood: 18,
  metal: 22,
  plastic: 8,
  composite: 12,
};

/** Premium surcharge multiplier */
export const PREMIUM_MULTIPLIER = 1.5;

/** Profile complexity surcharge (EUR per linear meter) */
export const FRAME_PROFILE_SURCHARGE: Record<string, number> = {
  flat: 0,
  rounded: 2,
  stepped: 3,
  ornate: 8,
  floater: 4,
};

/** Texture surcharge (EUR per linear meter) */
export const FRAME_TEXTURE_SURCHARGE: Record<string, number> = {
  smooth: 0,
  'wood-grain': 0,
  'brushed-metal': 2,
  distressed: 3,
  gilded: 12,
};

/** Mat pricing (EUR per mat board, standard size ~80×100cm) */
export const MAT_BASE_PRICE = 8;
export const MAT_PREMIUM_PRICE = 15;

/** Mat texture surcharge (EUR) */
export const MAT_TEXTURE_SURCHARGE: Record<string, number> = {
  smooth: 0,
  linen: 3,
  suede: 5,
  silk: 8,
};

/** Glass options (EUR per standard sheet ~50×70cm) */
export const GLASS_PRICES: Record<string, { label: string; price: number }> = {
  regular: { label: 'Regular Glass', price: 12 },
  'non-glare': { label: 'Non-Glare Glass', price: 25 },
  museum: { label: 'Museum Glass (UV)', price: 55 },
  acrylic: { label: 'Acrylic', price: 18 },
};

/** Labour cost (EUR, flat) */
export const LABOUR_COST = 15;

/** Minimum order (EUR) */
export const MINIMUM_ORDER = 25;
